module.exports = __webpack_public_path__ + "static/img/s1151.72d974e6.png";